module.exports = __webpack_public_path__ + "img/hardness@2x.f4b6f9f.webp";